import React from 'react'
import { Typography } from 'antd'
import { defaultSortOrder } from '../../../../../utils/table/defaultSortOrder'
import { columnSortTooltip } from '../../../../../utils/table/columnSortTooltip'
import { SORT_TEXTS } from '../../../../../constants/COLUMN_SORTER'
import moment from 'moment-timezone'

export const PaymentsCurrentYearColumn = (sortColumn: string, sortOrder: string) => {
  return {
    title: 'Invoice - ' + moment().year(),
    dataIndex: 'paymentsCurrentYear',
    defaultSortOrder: defaultSortOrder('paymentsCurrentYear', sortColumn, sortOrder),
    showSorterTooltip: columnSortTooltip({
      dataIndex: 'paymentsCurrentYear',
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      ascText: SORT_TEXTS.NUM_ASC,
      descText: SORT_TEXTS.NUM_DESC,
      cancelText: SORT_TEXTS.CANCEL
    }),
    sorter: true,
    className: 'table-column',
    render: (paymentsCurrentYear: number) => {
      return (
        <div>
          <Typography.Text>${paymentsCurrentYear && paymentsCurrentYear.toFixed(2).replace('.00', '')}</Typography.Text>
        </div>
      )
    }
  }
}
